export default "__VITE_ASSET__0c52vZzY__"